// Location-pin + semicolon brand mark (derived from the Recovery Rides logo).
export const PinMark = ({ className = "", id = "pinGrad", solid = false }) => (
  <svg viewBox="0 0 48 64" className={className} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#1AD1B9" />
        <stop offset="55%" stopColor="#00B4B4" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
    </defs>
    <path
      d="M24 1.5C11.6 1.5 1.5 11.3 1.5 23.5c0 6.4 3.9 13.3 8.9 19.6 4.6 5.8 9.8 10.6 12.2 12.8a2 2 0 0 0 2.8 0c2.4-2.2 7.6-7 12.2-12.8 5-6.3 8.9-13.2 8.9-19.6C46.5 11.3 36.4 1.5 24 1.5Z"
      fill={solid ? "#ffffff" : `url(#${id})`}
    />
    {/* semicolon dot */}
    <circle cx="24" cy="16.5" r="5" fill={solid ? "#0EAF9E" : "#ffffff"} />
    {/* semicolon comma */}
    <path
      d="M28.9 30.2a5 5 0 1 0-4.9 5.9c-.4 2.9-2 5.2-4.6 7 4.9-1.8 8.4-6.1 9.4-11.4.1-.5.1-1 .1-1.5Z"
      fill={solid ? "#0EAF9E" : "#ffffff"}
    />
  </svg>
);
